import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { ComponentEditorLabels } from '@/shared/components/packaging/ComponentEditor'

export function usePackagingSuppliersComponentEditorLabels(): ComponentEditorLabels {
  const { t } = useTranslation('packagingSuppliers')

  return useMemo(
    () => ({
      name: t('componentEditor.name'),
      namePlaceholder: t('componentEditor.namePlaceholder'),
      nameRequired: t('componentEditor.nameRequired'),
      material: t('componentEditor.material'),
      materialRequired: t('componentEditor.materialRequired'),
      selectMaterial: t('componentEditor.selectMaterial'),
      weightGrams: t('componentEditor.weightGrams'),
      weightGramsRequired: t('componentEditor.weightGramsRequired'),
      weightGramsInvalid: t('componentEditor.weightGramsInvalid'),
      recyclingStream: t('componentEditor.recyclingStream'),
      recyclingPercentage: t('componentEditor.recyclingPercentage'),
      recyclingPercentageInvalid: t('componentEditor.recyclingPercentageInvalid'),
      recyclable: t('componentEditor.recyclable'),
      reusable: t('componentEditor.reusable'),
      notes: t('componentEditor.notes'),
      notesPlaceholder: t('componentEditor.notesPlaceholder'),
      addComponent: t('componentEditor.addComponent'),
      editComponent: t('componentEditor.editComponent'),
      saveComponent: t('componentEditor.saveComponent'),
      emptyMessage: t('componentEditor.emptyMessage'),
      tableName: t('componentEditor.tableName'),
      tableMaterial: t('componentEditor.tableMaterial'),
      tableWeight: t('componentEditor.tableWeight'),
      tableWeightPercent: t('componentEditor.tableWeightPercent'),
      tableRecyclable: t('componentEditor.tableRecyclable'),
      tableRecyclingStream: t('componentEditor.tableRecyclingStream'),
      tableRecyclingPercent: t('componentEditor.tableRecyclingPercent'),
      tableReusable: t('componentEditor.tableReusable'),
      tableNotes: t('componentEditor.tableNotes'),
      tableActions: t('componentEditor.tableActions'),
      edit: t('componentEditor.edit'),
      remove: t('componentEditor.remove'),
      yes: t('componentEditor.yes'),
      no: t('componentEditor.no'),
      none: t('componentEditor.none'),
      cancel: t('componentEditor.cancel'),
      saving: t('componentEditor.saving'),
      materials: {
        PLASTIC: t('componentEditor.materials.PLASTIC'),
        PAPER_CARDBOARD: t('componentEditor.materials.PAPER_CARDBOARD'),
        GLASS: t('componentEditor.materials.GLASS'),
        METAL_ALUMINIUM: t('componentEditor.materials.METAL_ALUMINIUM'),
        METAL_STEEL: t('componentEditor.materials.METAL_STEEL'),
        WOOD: t('componentEditor.materials.WOOD'),
        OTHER: t('componentEditor.materials.OTHER'),
      },
      recyclingStreams: {
        GLASS: t('componentEditor.recyclingStreams.GLASS'),
        PAPER_CARDBOARD: t('componentEditor.recyclingStreams.PAPER_CARDBOARD'),
        PLASTICS_HDPE: t('componentEditor.recyclingStreams.PLASTICS_HDPE'),
        PLASTICS_PET: t('componentEditor.recyclingStreams.PLASTICS_PET'),
        PLASTICS_PP: t('componentEditor.recyclingStreams.PLASTICS_PP'),
        PLASTICS_LDPE: t('componentEditor.recyclingStreams.PLASTICS_LDPE'),
        OTHER_RECYCLABLE_WASTE: t(
          'componentEditor.recyclingStreams.OTHER_RECYCLABLE_WASTE'
        ),
        NONE: t('componentEditor.recyclingStreams.NONE'),
      },
    }),
    [t]
  )
}
